import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme, align, isSort }) => ({
    '& .wrap': {
        display: 'inline-block',
        position: 'relative',
        padding: toRems([0, 20, 0, 0]),
        marginBottom: toRem(20),

        [theme.breakpoints.down('md')]: {
            padding: isSort ? 0 : toRems([0, 20, 0, 0]),
            width: '100%',

            '& .label-text': {
                display: isSort ? 'none' : 'inline',
                padding: '4px 20px'
            }
        },

        [theme.breakpoints.only('md')]: {
            width: '35%',
            float: 'left',
            bottom: '60px',
            left: '35%'
        },

        '&.is-desktop': {
            cursor: 'pointer',
            display: 'none'
        },

        [theme.breakpoints.up('lg')]: {
            display: 'none',

            '&.is-desktop': {
                display: 'inline-block'
            }
        }
    },

    '& select, & .label': {
        display: 'inline-block',
        fontSize: toRem(16),
        color: theme.colors.white,
        boxSizing: 'border-box',
        margin: 0,
        appearance: 'none',
        background: 'transparent',
        border: 'none',
        padding: 0,
        textAlign: 'center',

        [theme.breakpoints.down('md')]: {
            border: isSort ? '2px solid #ffffff' : 'none',
            borderRadius: isSort ? 20 : '',
            width: '100%',
            padding: isSort ? toRems([9, 20, 9, 20]) : 0
        },

        [theme.breakpoints.up('lg')]: {
            fontSize: toRem(16)
        }
    },

    '& .label': {
        textAlign: 'align',
        lineHeight: toRem(25),
        height: toRem(25),
        whiteSpace: 'nowrap',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',

        span: {
            visibility: 'hidden',
            height: 0,
            display: align === 'left' ? 'none' : 'inline'
        }
    },

    '& select::-ms-expand': {
        display: 'none'
    },

    '& .options': {
        position: 'absolute',
        top: 'calc(100% + 16px)',
        left: -50,
        zIndex: 99,
        borderTop: `1px solid ${theme.colors.blueDark}`,
        overflowX: 'auto',
        maxHeight: 'calc(100vh - 76px)',
        whiteSpace: 'nowrap',
        display: 'none',
        flexDirection: 'column'
    },

    '& .is-opened .options': {
        display: 'flex'
    },

    '& .option': {
        justifyContent: 'space-between',
        background: theme.colors.blueMid,
        borderBottom: `1px solid ${theme.colors.blueDark}`,
        color: theme.colors.white,
        textAlign: 'left',
        fontSize: toRem(14),
        minWidth: align === 'left' ? toRem(280) : null,
        padding: toRems([16, 50]),

        '&.is-selected': {
            display: 'none'
        }
    },

    '& .arrow': {
        position: 'absolute',
        top: '50%',
        transform: 'translate(0, -50%)',
        marginTop: -2,
        right: 1,
        width: 10,
        height: 10,
        lineHeight: 0,
        pointerEvents: 'none',

        [theme.breakpoints.down('md')]: {
            right: isSort ? 23 : 0
        },

        path: {
            stroke: theme.colors.white,
            strokeWidth: 2
        }
    }
})

export default style
